import { Navigate, useSearchParams } from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import LoadingSpinner from "./LoadingSpinner";
import { useAuthUser } from "./dashboard/hooks/useAuthUser";

export function LoginRoute() {
  const { isAuthenticated, detailsLoading, token } = useAuthUser();
  const [searchParams] = useSearchParams();
  const redirectToParam = searchParams.get("redirect");
  const redirectTo = redirectToParam
    ? decodeURIComponent(redirectToParam).replace(/^\/+/, "")
    : null;

  if (token && detailsLoading) {
    return <LoadingSpinner className="loading-spinner-container--fullscreen" />;
  }

  if (isAuthenticated) {
    return (
      <Navigate
        to={redirectTo ? `/${redirectTo}` : "/profile"}
        replace
      />
    );
  }

  return <LoginPage />;
}
